var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "car-lifted-pickup",
    d: "M17.648,16.6l.75.095-.019.218.446.161.142-.152a2.791,2.791,0,0,1,1.149,1.1l-.161.161.19.427.218-.019a2.871,2.871,0,0,1,.133.855l-.095.741-.228-.009-.18.446.18.142a2.794,2.794,0,0,1-1.1,1.149l-.161-.171-.437.19.019.228a2.763,2.763,0,0,1-.845.133L16.9,22.2l.009-.237-.437-.171-.152.18a2.852,2.852,0,0,1-1.149-1.1l.171-.171-.19-.437-.228.019a3.014,3.014,0,0,1-.123-.836l.1-.76.218.01.18-.437-.171-.142a2.829,2.829,0,0,1,1.092-1.149l.161.161.437-.19-.019-.209a2.763,2.763,0,0,1,.845-.133m0,1.425a1.425,1.425,0,1,0,1.425,1.425,1.423,1.423,0,0,0-1.425-1.425M6.249,16.6l.75.095-.019.218.446.161.142-.152a2.791,2.791,0,0,1,1.149,1.1l-.161.161.19.427.218-.019a2.871,2.871,0,0,1,.133.855L9,20.19l-.237-.009-.171.446.18.142a2.794,2.794,0,0,1-1.1,1.149l-.161-.171-.437.19.019.228a2.763,2.763,0,0,1-.845.133L5.5,22.2l.009-.237-.437-.171-.152.18a2.852,2.852,0,0,1-1.149-1.1l.171-.171-.19-.437-.228.019a3.014,3.014,0,0,1-.123-.836l.1-.76.218.009.18-.437-.171-.142a2.829,2.829,0,0,1,1.092-1.149l.161.161.437-.19L5.4,16.732a2.763,2.763,0,0,1,.845-.133m0,1.425a1.425,1.425,0,1,0,1.425,1.425,1.423,1.423,0,0,0-1.425-1.425M15.748,9l2.85,3.8h1.9a1.893,1.893,0,0,1,1.9,1.9v2.85H20.5a2.85,2.85,0,0,0-5.7,0H9.1a2.85,2.85,0,1,0-5.7,0H1.5V12.8h9.024V9h5.224m-3.8,1.425V12.8h5.186l-1.862-2.375Z",
    transform: "translate(0.5 -4)",
    fill: "#f5f5f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrink);
export default __webpack_public_path__ + "static/media/trink.72e95d2ce21cec651187b606e0c1b27b.svg";
export { ForwardRef as ReactComponent };